export function scrollToDemoForm(): void {
  document.getElementById('demo-form')?.scrollIntoView({ behavior: 'smooth' });
}
